export default __webpack_public_path__ + "static/media/phpfront.1a7f05d2.svg";